import type { SortingOption } from '@/components/shared/tattoo/filters/SortingFilter'
import type { ArtistSortingOption } from '@/components/shared/artist/ArtistSortingFilter'
import type { DiscoverFilterDraft } from '@/components/discover/DiscoverFilterSheet'
import type { DiscoverType, DiscoverUrlFilterState } from '@/hooks/useDiscoverUrlFilters'

export const DEFAULT_DISCOVER_FILTER_DRAFT: DiscoverFilterDraft = {
  discoverType: 'flashes',
  selectedLocations: [],
  tattooSorting: 'recent',
  artistSorting: 'discover',
  includeBooked: false,
  showDeals: false,
  showFollowingOnly: false,
  activeTab: 'list',
}

export function isDefaultDiscoverSorting(
  discoverType: DiscoverType,
  tattooSorting: SortingOption,
  artistSorting: ArtistSortingOption,
): boolean {
  if (discoverType === 'artists') {
    return artistSorting === 'discover'
  }
  return tattooSorting === 'recent'
}

export function hasNonDefaultDiscoverFilters(
  filters: Pick<
    DiscoverUrlFilterState | DiscoverFilterDraft,
    | 'discoverType'
    | 'tattooSorting'
    | 'artistSorting'
    | 'showDeals'
    | 'includeBooked'
    | 'showFollowingOnly'
  >,
  locationEffectivelyAll: boolean,
): boolean {
  return (
    filters.discoverType !== DEFAULT_DISCOVER_FILTER_DRAFT.discoverType ||
    !locationEffectivelyAll ||
    filters.showDeals ||
    filters.includeBooked ||
    filters.showFollowingOnly ||
    !isDefaultDiscoverSorting(
      filters.discoverType,
      filters.tattooSorting,
      filters.artistSorting,
    )
  )
}
